import { Image } from 'react-native';
import { useScreenSize } from '@banhala/ui-kit';

export const FavoriteMarketEmpty = () => {
  const { width } = useScreenSize();
  return (
    <Image
      source={require('./images/image_favorite_market_empty.jpg')}
      style={{ width, height: width * (366 / 360) }}
      resizeMode={'contain'}
    />
  );
};
